const navItems = document.querySelectorAll('.main-header__menu ul li:not(.main-header__menu__property-search)');

let leaving = null;
let hoverTimeout = null;

navItems.forEach(function(elem) {
    elem.addEventListener("mouseenter", function(event) {
        const classes = event.target.classList;

        // Reset timeout and remove hover if just left another nav item.
        clearTimeout(hoverTimeout);
        if (leaving) { 
            leaving.classList.remove("hover");
            leaving = null;
        }
        
        // only add class to menu elements that aren't active
        if (!classes.contains("is-active")) {
            classes.add("hover");
        }

    });

    elem.addEventListener("mouseleave", function(event) {
        leaving = event.target;
        hoverTimeout = setTimeout(() => {
            event.target.classList.remove("hover");
        }, 1250);        
    });
});


// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/MainNav.jsx